import React, { ReactElement, SVGProps } from 'react';
import Alert from './Alert';
import ArrowDown from './ArrowDown';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import ArrowUp from './ArrowUp';
import ArrowsUpDown from './ArrowsUpDown';
import BellCrossed from './BellCrossed';
import BellFull from './BellFull';
import Bell from './Bell';
import BookmarkFilled from './BookmarkFilled';
import Bookmark from './Bookmark';
import Brand from './Brand';
import Buy from './Buy';
import CaretArrowDown from './CaretArrowDown';
import CaretArrowUp from './CaretArrowUp';
import CaretDoubleLeft from './CaretDoubleLeft';
import CaretDoubleRight from './CaretDoubleRight';
import CaretDownFat from './CaretDownFat';
import CaretDown from './CaretDown';
import CaretLeft from './CaretLeft';
import CaretRight from './CaretRight';
import Check from './Check';
import CheckmarkSmall from './CheckmarkSmall';
import Checkmark from './Checkmark';
import Clear from './Clear';
import Close from './Close';
import ColorLogo from './ColorLogo';
import Columns from './Columns';
import Companies from './Companies';
import Copy from './Copy';
import CozyView from './CozyView';
import Csv from './Csv';
import Dashboard from './Dashboard';
import Deals from './Deals';
import Delete from './Delete';
import Doc from './Doc';
import Download from './Download';
import Draggable from './Draggable';
import Edit from './Edit';
import Events from './Events';
import Expand from './Expand';
import ExpandedView from './ExpandedView';
import ExternalWindow from './ExternalWindow';
import Feeds from './Feeds';
import Filters from './Filters';
import Gear from './Gear';
import GetHelp from './GetHelp';
import Hold from './Hold';
import InfoFilled from './InfoFilled';
import Info from './Info';
import Like from './Like';
import LockOutline from './LockOutline';
import MarketStats from './MarketStats';
import Marketperform from './Marketperform';
import Markets from './Markets';
import MenuDots from './MenuDots';
import More from './More';
import NoContent from './NoContent';
import Norecommendation from './Norecommendation';
import NotFound from './NotFound';
import NotOnboarded from './NotOnboarded';
import NotSelected from './NotSelected';
import Outperform from './Outperform';
import Pdf from './Pdf';
import Plus from './Plus';
import Pptx from './Pptx';
import Print from './Print';
import Refresh from './Refresh';
import ScoreCore from './ScoreCore';
import ScoreModerateRisk from './ScoreModerateRisk';
import ScoreSpeculative from './ScoreSpeculative';
import ScoreStrategic from './ScoreStrategic';
import Search from './Search';
import Sectors from './Sectors';
import Sell from './Sell';
import ShareFilled from './ShareFilled';
import Share from './Share';
import SortAscending from './SortAscending';
import SortDescending from './SortDescending';
import Sort from './Sort';
import SpecialSituations from './SpecialSituations';
import Times from './Times';
import TriangleDown from './TriangleDown';
import TriangleUp from './TriangleUp';
import Underperform from './Underperform';
import Upload from './Upload';
import User from './User';
import Warning from './Warning';
import WhiteLogo from './WhiteLogo';
import Xlsx from './Xlsx';

export enum ICONS {
  Alert = 'Alert',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  ArrowsUpDown = 'ArrowsUpDown',
  BellCrossed = 'BellCrossed',
  BellFull = 'BellFull',
  Bell = 'Bell',
  BookmarkFilled = 'BookmarkFilled',
  Bookmark = 'Bookmark',
  Brand = 'Brand',
  Buy = 'Buy',
  CaretArrowDown = 'CaretArrowDown',
  CaretArrowUp = 'CaretArrowUp',
  CaretDoubleLeft = 'CaretDoubleLeft',
  CaretDoubleRight = 'CaretDoubleRight',
  CaretDownFat = 'CaretDownFat',
  CaretDown = 'CaretDown',
  CaretLeft = 'CaretLeft',
  CaretRight = 'CaretRight',
  Check = 'Check',
  CheckmarkSmall = 'CheckmarkSmall',
  Checkmark = 'Checkmark',
  Clear = 'Clear',
  Close = 'Close',
  ColorLogo = 'ColorLogo',
  Columns = 'Columns',
  Companies = 'Companies',
  Copy = 'Copy',
  CozyView = 'CozyView',
  Csv = 'Csv',
  Dashboard = 'Dashboard',
  Deals = 'Deals',
  Delete = 'Delete',
  Doc = 'Doc',
  Download = 'Download',
  Draggable = 'Draggable',
  Edit = 'Edit',
  Events = 'Events',
  Expand = 'Expand',
  ExpandedView = 'ExpandedView',
  ExternalWindow = 'ExternalWindow',
  Feeds = 'Feeds',
  Filters = 'Filters',
  Gear = 'Gear',
  GetHelp = 'GetHelp',
  Hold = 'Hold',
  InfoFilled = 'InfoFilled',
  Info = 'Info',
  Like = 'Like',
  LockOutline = 'LockOutline',
  MarketStats = 'MarketStats',
  Marketperform = 'Marketperform',
  Markets = 'Markets',
  MenuDots = 'MenuDots',
  More = 'More',
  NoContent = 'NoContent',
  Norecommendation = 'Norecommendation',
  NotFound = 'NotFound',
  NotOnboarded = 'NotOnboarded',
  NotSelected = 'NotSelected',
  Outperform = 'Outperform',
  Pdf = 'Pdf',
  Plus = 'Plus',
  Pptx = 'Pptx',
  Print = 'Print',
  Refresh = 'Refresh',
  ScoreCore = 'ScoreCore',
  ScoreModerateRisk = 'ScoreModerateRisk',
  ScoreSpeculative = 'ScoreSpeculative',
  ScoreStrategic = 'ScoreStrategic',
  Search = 'Search',
  Sectors = 'Sectors',
  Sell = 'Sell',
  ShareFilled = 'ShareFilled',
  Share = 'Share',
  SortAscending = 'SortAscending',
  SortDescending = 'SortDescending',
  Sort = 'Sort',
  SpecialSituations = 'SpecialSituations',
  Times = 'Times',
  TriangleDown = 'TriangleDown',
  TriangleUp = 'TriangleUp',
  Underperform = 'Underperform',
  Upload = 'Upload',
  User = 'User',
  Warning = 'Warning',
  WhiteLogo = 'WhiteLogo',
  Xlsx = 'Xlsx',
}

const getIcon = (props: SVGProps<SVGSVGElement>) => ({
  Alert: <Alert {...props} />,
  ArrowDown: <ArrowDown {...props} />,
  ArrowLeft: <ArrowLeft {...props} />,
  ArrowRight: <ArrowRight {...props} />,
  ArrowUp: <ArrowUp {...props} />,
  ArrowsUpDown: <ArrowsUpDown {...props} />,
  BellCrossed: <BellCrossed {...props} />,
  BellFull: <BellFull {...props} />,
  Bell: <Bell {...props} />,
  BookmarkFilled: <BookmarkFilled {...props} />,
  Bookmark: <Bookmark {...props} />,
  Brand: <Brand {...props} />,
  Buy: <Buy {...props} />,
  CaretArrowDown: <CaretArrowDown {...props} />,
  CaretArrowUp: <CaretArrowUp {...props} />,
  CaretDoubleLeft: <CaretDoubleLeft {...props} />,
  CaretDoubleRight: <CaretDoubleRight {...props} />,
  CaretDownFat: <CaretDownFat {...props} />,
  CaretDown: <CaretDown {...props} />,
  CaretLeft: <CaretLeft {...props} />,
  CaretRight: <CaretRight {...props} />,
  Check: <Check {...props} />,
  CheckmarkSmall: <CheckmarkSmall {...props} />,
  Checkmark: <Checkmark {...props} />,
  Clear: <Clear {...props} />,
  Close: <Close {...props} />,
  ColorLogo: <ColorLogo {...props} />,
  Columns: <Columns {...props} />,
  Companies: <Companies {...props} />,
  Copy: <Copy {...props} />,
  CozyView: <CozyView {...props} />,
  Csv: <Csv {...props} />,
  Dashboard: <Dashboard {...props} />,
  Deals: <Deals {...props} />,
  Delete: <Delete {...props} />,
  Doc: <Doc {...props} />,
  Download: <Download {...props} />,
  Draggable: <Draggable {...props} />,
  Edit: <Edit {...props} />,
  Events: <Events {...props} />,
  Expand: <Expand {...props} />,
  ExpandedView: <ExpandedView {...props} />,
  ExternalWindow: <ExternalWindow {...props} />,
  Feeds: <Feeds {...props} />,
  Filters: <Filters {...props} />,
  Gear: <Gear {...props} />,
  GetHelp: <GetHelp {...props} />,
  Hold: <Hold {...props} />,
  InfoFilled: <InfoFilled {...props} />,
  Info: <Info {...props} />,
  Like: <Like {...props} />,
  LockOutline: <LockOutline {...props} />,
  MarketStats: <MarketStats {...props} />,
  Marketperform: <Marketperform {...props} />,
  Markets: <Markets {...props} />,
  MenuDots: <MenuDots {...props} />,
  More: <More {...props} />,
  NoContent: <NoContent {...props} />,
  Norecommendation: <Norecommendation {...props} />,
  NotFound: <NotFound {...props} />,
  NotOnboarded: <NotOnboarded {...props} />,
  NotSelected: <NotSelected {...props} />,
  Outperform: <Outperform {...props} />,
  Pdf: <Pdf {...props} />,
  Plus: <Plus {...props} />,
  Pptx: <Pptx {...props} />,
  Print: <Print {...props} />,
  Refresh: <Refresh {...props} />,
  ScoreCore: <ScoreCore {...props} />,
  ScoreModerateRisk: <ScoreModerateRisk {...props} />,
  ScoreSpeculative: <ScoreSpeculative {...props} />,
  ScoreStrategic: <ScoreStrategic {...props} />,
  Search: <Search {...props} />,
  Sectors: <Sectors {...props} />,
  Sell: <Sell {...props} />,
  ShareFilled: <ShareFilled {...props} />,
  Share: <Share {...props} />,
  SortAscending: <SortAscending {...props} />,
  SortDescending: <SortDescending {...props} />,
  Sort: <Sort {...props} />,
  SpecialSituations: <SpecialSituations {...props} />,
  Times: <Times {...props} />,
  TriangleDown: <TriangleDown {...props} />,
  TriangleUp: <TriangleUp {...props} />,
  Underperform: <Underperform {...props} />,
  Upload: <Upload {...props} />,
  User: <User {...props} />,
  Warning: <Warning {...props} />,
  WhiteLogo: <WhiteLogo {...props} />,
  Xlsx: <Xlsx {...props} />,
});

interface IconProps extends SVGProps<SVGSVGElement> {
  icon: ICONS;
  'aria-label': string | ICONS;
  tabIndex: number | undefined;
}
const SVGIcon = ({ icon, ...props }: IconProps): ReactElement => {
  const component = getIcon(props)[icon];
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{component}</>;
};

export default SVGIcon;
